// extracted by mini-css-extract-plugin
export default {"container":"About_container__hzadW","content":"About_content__1whNN","button":"About_button__5mTMi"};